// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".MultiPaperModal-cls1__d258b7f2f532bbd9ce07{/*!*/}.MultiPaperModal-cls2___4a07bb53ddbd8c8d660{display:flex;flex-direction:column;grid-gap:35px;gap:35px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "MultiPaperModal-cls1__d258b7f2f532bbd9ce07",
	"cls2": "MultiPaperModal-cls2___4a07bb53ddbd8c8d660 MultiPaperModal-cls1__d258b7f2f532bbd9ce07"
};
export default ___CSS_LOADER_EXPORT___;
